export function simulateDelay(delay = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, delay));
}
